/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:68b130d6-f347-4dd3-88db-5b4114173480",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_LPRMIEshM",
    "aws_user_pools_web_client_id": "1bfiar4ks2hpl4dabb827f367f",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "kubiaManageUserApi",
            "endpoint": "https://ks8714ry6e.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
